import { render, staticRenderFns } from "./ProductProfit.vue?vue&type=template&id=75c83866&"
import script from "./ProductProfit.vue?vue&type=script&lang=js&"
export * from "./ProductProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports